import React, { useEffect, useState } from "react";
import { getBlogs, deleteBlog } from "../../api/BlogCategoryService";
import { FaPlus, FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function BlogCategoryList() {
  const navigate = useNavigate();

  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchBlogs = async () => {
    try {
      setLoading(true);

      const res = await getBlogs();

      setBlogs(Array.isArray(res?.data) ? res.data : []);
    } catch (err) {
      console.error("Failed to fetch blog categories:", err);
      setBlogs([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const handleDelete = async (id) => {
    try {
      const confirmDelete = window.confirm(
        "Are you sure you want to delete this blog category?",
      );

      if (!confirmDelete) return;

      const res = await deleteBlog(id);

      if (res.success) {
        fetchBlogs();
      }
    } catch (error) {
      console.error("Delete error:", error);
    }
  };

  return (
    <div className="container-fluid p-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Blog Category List</h5>

        <button
          className="btn btn-primary d-flex align-items-center gap-2"
          onClick={() => navigate("/blogcategory/add")}
        >
          <FaPlus />
          Add Blog Category
        </button>
      </div>

      {loading && <p>Loading blog categories...</p>}

      {!loading && blogs.length === 0 && (
        <p className="text-secondary">No blog categories found</p>
      )}

      <div className="row g-4 justify-content-start">
        {blogs.map((blog) => (
          <div className="col-md-6 d-flex" key={blog._id}>
            <div
              className="w-100"
              style={{
                borderRadius: "12px",
                padding: "15px",
                backgroundColor: "#ffffff",
              }}
            >
              <div className="d-flex align-items-start gap-4">
                <div className="flex-grow-1">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <h5 className="fw-semibold text-dark mb-0">
                      {blog.name || "-"}
                    </h5>

                    <div className="d-flex gap-3">
                      <button
                        className="border-0 bg-transparent p-0"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate(`/blogcategory/view/${blog.slug}`)
                        }
                      >
                        <FaEye size={14} color="black" />
                      </button>

                      <button
                        className="border-0 bg-transparent p-0"
                        onClick={() =>
                          navigate(`/blogcategory/edit/${blog.slug}`, {
                            state: {
                              blogId: blog._id,
                              slug: blog.slug,
                            },
                          })
                        }
                      >
                        <FaEdit size={14} color="black" />
                      </button>
                      <button
                        className="border-0 bg-transparent p-0"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDelete(blog._id)}
                      >
                        <FaTrash size={14} />
                      </button>
                    </div>
                  </div>

                  <p className="mb-1">
                    <strong>Slug:</strong> {blog.slug || "-"}
                  </p>

                  <p className="mb-1">
                    <strong>Description:</strong>{" "}
                    {blog.description || "No description"}
                  </p>

                  <p className="fw-medium mb-0 text-dark">
                    <strong>Status:</strong>{" "}
                    <span
                      className={
                        blog.status === "ACTIVE"
                          ? "badge bg-success"
                          : "badge bg-secondary"
                      }
                    >
                      {blog.status || "INACTIVE"}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
